import React from 'react';
import { cn, getAlertClasses } from './baseUIConfig';

export const Alert = ({
  children,
  variant = 'info',
  className = '',
  onClose,
  title,
}) => {
  const icons = {
    info: '💡',
    success: '✅',
    warning: '⚠️',
    error: '❌',
  };

  return (
    <div
      className={cn(getAlertClasses(variant), className)}
      role="alert"
    >
      <span className="text-xl" aria-hidden="true">{icons[variant] || icons.info}</span>
      <div className="flex-1">
        {title && (
          <h4 className="font-semibold mb-1">{title}</h4>
        )}
        <div>{children}</div>
      </div>
      {onClose && (
        <button
          onClick={onClose}
          className="ml-2 opacity-70 transition-opacity hover:opacity-100"
          aria-label="Close alert"
        >
          ✕
        </button>
      )}
    </div>
  );
};
